import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 py-20">
        <span className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none leading-none">
          404
        </span>
        <h1 className="mt-6 text-xl md:text-2xl font-heading font-bold text-foreground-950">
          {t("article.notFound")}
        </h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <Link
          to={`/${i18n.language}`}
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line text-sm"></i>
          </span>
          {t("article.backHome")}
        </Link>
      </div>
    </div>
  );
}